import React from 'react';

const InfoTile = ({ tone = 'indigo', title, children, icon }) => {
  const tones = {
    indigo: 'bg-indigo-50/50 border-indigo-100 bg-indigo-100 text-indigo-600',
    purple: 'bg-purple-50/50 border-purple-100 bg-purple-100 text-purple-600',
    blue: 'bg-blue-50/50 border-blue-100 bg-blue-100 text-blue-600',
    green: 'bg-green-50/50 border-green-100 bg-green-100 text-green-600',
    pink: 'bg-pink-50/50 border-pink-100 bg-pink-100 text-pink-600',
  };
  const [panelBg, panelBorder, iconBg, iconColor] = (tones[tone] || tones.indigo).split(' ');

  return (
    <div className={`flex items-start gap-4 p-4 rounded-xl border ${panelBg} ${panelBorder}`}>
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${iconBg}`}>
        <span className={iconColor}>{icon}</span>
      </div>
      <div>
        <p className="font-semibold text-gray-900 mb-1">{title}</p>
        <div className="text-gray-700">{children}</div>
      </div>
    </div>
  );
};

export default InfoTile;
